<div class="position-relative">
  @if (headers().length === 1) {
    <app-header
      [transparentNav]="headers()[0].transparentImage"
      [subtitle]="headers()[0].subtitle"
      [title]="headers()[0].title"
      [text]="headers()[0].intro"
      [media]="headers()[0].image"
      [button]="headers()[0].button"
      [isSlider]="false"
    ></app-header>
  } @else {
    <app-embla-slider
      [slides]="headers()"
      [showDots]="false"
      [showArrows]="false"
      style="--slider-height: auto; --slider-gap: 0"
      [navButtonClasses]="'button button--lg button-icon button--accent'"
      [options]="{ dragFree: false, skipSnaps: false, loop: true }"
      [plugins]="[fade]"
      (slideChange)="activeSlideIndex.set($event)"
      #sliderEl
    >
      @for (header of headers(); track header) {
        <app-header
          [transparentNav]="header.transparentImage"
          [subtitle]="header.subtitle"
          [title]="header.title"
          [text]="header.intro"
          [media]="header.image"
          [button]="header.button"
          [isSlider]="true"
        ></app-header>
      }
    </app-embla-slider>

    <footer class="slider__bottom">
      <div class="container d-flex justify-content-end align-items-center">
        <button
          class="is--prev button button-link button--light"
          [class.set--inactive]="!slider()?.canScrollPrev()"
          (click)="slider()?.prev()"
          aria-label="Vorige slide"
        >
          <app-icon class="icon-xxs" anchor="icon-chevron-left-xs"></app-icon>
        </button>

        <div class="slider-pagination type-body-xs mx-1">
          <strong>{{ activeSlideIndex() + 1 }}&nbsp;</strong>
          <span>/ {{ headers().length }}</span>
        </div>
        <button
          class="is--next button button-link button--light"
          [class.set--inactive]="!slider()?.canScrollNext()"
          (click)="slider()?.next()"
          aria-label="Volgende slide"
        >
          <app-icon class="icon-xxs" anchor="icon-chevron-right-xs"></app-icon>
        </button>
      </div>
    </footer>
  }
</div>
